import React from "react";
import * as Styles from "../style";
import { FormControl, Radio, RadioGroup } from "@mui/material";
import HookPayPoints from "../../hooks";

const Points = () => {
  const { ChangeValuePoints, valuePoints, LoadingPoints, dataPoints } =
    HookPayPoints();

  return (
    <>
      {!LoadingPoints && dataPoints ? (
        <Styles.Section>
          <FormControl style={{ width: "100%" }}>
            <Styles.TextHeader variant="h3">النقاط</Styles.TextHeader>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name={`controlled-radio-buttons-group`}
              value={valuePoints}
              onChange={ChangeValuePoints}
            >
              {dataPoints.data?.data?.points.map((el, i) => (
                <Styles.Content key={i}>
                  <Styles.FormControlCus
                    value={JSON.stringify(el)}
                    control={<Radio />}
                    label={`${el.number_of_points} نقطة`}
                  />
                  <span>
                    {el.price}{" "}
                    <span style={{ color: "green", fontSize: "12px" }}>
                      {" "}
                      ل.س
                    </span>
                  </span>
                </Styles.Content>
              ))}
            </RadioGroup>
          </FormControl>
        </Styles.Section>
      ) : null}
    </>
  );
};

export default Points;
